import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Header, Table, Label, Button, Icon, Input, Image, Popup } from 'semantic-ui-react';
import i18next from 'i18next';

import takeaway from '../../../assets/icons/pack.svg';
import table from '../../../assets/icons/table.png';
import delivery from '../../../assets/icons/delivery.png';
import quickpay from '../../../assets/icons/quickpay.png';
import invoice from '../../../assets/icons/invoice.png';
import kiosk from '../../../assets/icons/kiosk.png';

import takeawayDisabled from '../../../assets/icons/pack-disabled.svg';
import tableDisabled from '../../../assets/icons/table-disabled.png';
import deliveryDisabled from '../../../assets/icons/delivery-disabled.png';
import quickpayDisabled from '../../../assets/icons/quickpay-disabled.png';
import invoiceDisabled from '../../../assets/icons/invoice-disabled.png';
import kioskDisabled from '../../../assets/icons/kiosk-disabled.png';

import './Restaurants.scss';

class SupportedOrderOptions extends Component {

    supportOptions = {
        supportCartOrderTable: {
            icon: <Image src={table} avatar />,
            disabled: <Image src={tableDisabled} avatar />,
            translation: 'sitting'
        },
        supportCartOrderPickup: {
            icon: <Image src={takeaway} avatar />,
            disabled: <Image src={takeawayDisabled} avatar />,
            translation: 'takeaway'
        },
        supportCartOrderDelivery: {
            icon: <Image src={delivery} avatar />,
            disabled: <Image src={deliveryDisabled} avatar />,
            translation: 'deliveries'
        },
        supportQuickPayment: {
            icon: <Image src={quickpay} avatar />,
            disabled: <Image src={quickpayDisabled} avatar />,
            translation: 'quickPay'
        },
        supportTableOrderCode: {
            icon: <Image src={invoice} avatar />,
            disabled: <Image src={invoiceDisabled} avatar />,
            translation: 'tableNumber'
        },
        supportKiosk: {
            icon: <Image src={kiosk} avatar />,
            disabled: <Image src={kioskDisabled} avatar />,
            translation: 'kiosk'
        }
    };

    render() {
        const { restaurant } = this.props;
               
        return (
            <div className="pi-supported-order-options-disabled">
                {Object.keys(this.supportOptions).map((support, index) => {
                    return <Popup key={index}
                        trigger={restaurant[support] ? this.supportOptions[support].icon : this.supportOptions[support].disabled}
                        content={i18next.t(this.supportOptions[support].translation)}
                        size='small' inverted position='top center'
                        className={restaurant[support] ? 'pi-supported-order-options-disabled': ''}
                    />;
                }).filter(support => !!support)}
            </div>
        );
    }
}

SupportedOrderOptions.propTypes = {
    restaurant: PropTypes.object,
    
};


export default SupportedOrderOptions;
